export { default } from './OpenDocumentsPaneButton';
